module.exports = __webpack_public_path__ + "static/media/group_30.92175ba4.png";